import { sendHttp } from '../assets/js/request'

const dataAnalysisApi = {
  // 获取血糖统计页面数据
  gluStatisticsByDept (params) {
    return sendHttp('get', '/system/bg_analysis/gluStatisticsByDept', params)
  },
  // 获取血糖分布图接口
  getGluCriseByMeasure (params) {
    return sendHttp('get', '/system/bg_analysis/gluStatisticsByDept/gluCriseByMeasure', params)
  },
  // 获取性别分布
  getGluGenderByPatients (params) {
    return sendHttp('get', '/system/bg_analysis/gluStatisticsByDept/gluGenderByPatients', params)
  },
  // 获取年龄分布
  getGluAgeByPatients (params) {
    return sendHttp('get', '/system/bg_analysis/gluStatisticsByDept/gluAgeByPatients', params)
  },
  // 获取测量次数分布
  getGluMeasureByDays (params) {
    return sendHttp('get', '/system/bg_analysis/gluStatisticsByDept/gluMeasureByDays', params)
  },
  // 获取血糖测量人数比例分布
  getGluQualifiedByPatients (params) {
    return sendHttp('get', '/system/bg_analysis/gluStatisticsByDept/gluQualifiedByPatients', params)
  },
  // 获取血糖测量次数比例分布
  getGluQualifiedByMeasure (params) {
    return sendHttp('get', '/system/bg_analysis/gluStatisticsByDept/gluQualifiedByMeasure', params)
  },
  // 数据分布界面数据获取
  getDataDistribution (params) {
    return sendHttp('get', '/system/bg_analysis/bgDistribution', params)
  },
  // 数据分布按照人数统计
  getPatientDistribution (params) {
    return sendHttp('get', '/system/bg_analysis/bgDistribution/countByPatient', params)
  },
  // 数据分布按照次数统计
  getMeasureDistribution (params) {
    return sendHttp('get', '/system/bg_analysis/bgDistribution/countByFrequency', params)
  },
  // 次数统计
  getDeptStatistics (params) {
    return sendHttp('get', '/follow-up/deptStatisicByYear', params)
  }
}

export {dataAnalysisApi}



// WEBPACK FOOTER //
// ./src/apis/dataAnalysisApi.js